module.exports = __webpack_public_path__ + "img/postback-step-6.ru.f4a44e2d.jpg";